export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-14',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
